import { render } from "./ModelListInModal.vue?vue&type=template&id=18bc2538"
import script from "./ModelListInModal.vue?vue&type=script&lang=js"
export * from "./ModelListInModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__